module.exports = __webpack_public_path__ + "static/media/logo-name.7207e402.png";